import api from './api';

export const zkTimeService = {
  async getCurrentTime(machineIp: string, port: number = 4370) {
    return api.post('/zktime/get-current-time', { machineIp, port });
  },

  async updateTime(machineIp: string, time: string, port: number = 4370) {
    return api.post('/zktime/update-time', { machineIp, time, port });
  },

  async syncTime(machineIp: string, port: number = 4370) {
    return api.post('/zktime/sync-time', { machineIp, port });
  }
};
